import {Badge, Skeleton, Typography} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {PageContent, PageLayout} from '@/layouts';

import {BuyerAssetContentSkeleton} from './BuyerAssetContent.skeleton';
import {BuyerViewHeaderSkeleton} from './BuyerViewHeader.skeleton';

export function BuyerViewSkeleton() {
  const {t} = useTranslation('trustAccounts');

  return (
    <PageLayout>
      <BuyerViewHeaderSkeleton />
      <PageContent className="flex flex-col gap-8">
        <div className="flex items-center justify-between border-b border-border-subtle pb-4">
          <div className="flex items-center gap-2">
            <Typography size="lg" weight="semibold">
              {t('view.buyers.detail.purchasedUnits')}
            </Typography>
            <Badge variant="neutral" size="lg">
              <Skeleton className="h-4 w-8" />
            </Badge>
          </div>
        </div>

        <BuyerAssetContentSkeleton />
      </PageContent>
    </PageLayout>
  );
}
